import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-10" }
const _hoisted_2 = {
  key: 0,
  class: "flexDiv"
}
const _hoisted_3 = { class: "sideplan-list-title" }
const _hoisted_4 = {
  key: 0,
  class: "price-block"
}
const _hoisted_5 = { class: "price-block-amount" }
const _hoisted_6 = {
  key: 1,
  class: "price-block"
}
const _hoisted_7 = {
  key: 1,
  class: "fw-ic gap-1"
}
const _hoisted_8 = { class: "location-block-icon" }
const _hoisted_9 = { class: "location-block-title" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "location-block" }
const _hoisted_12 = { class: "location-block-address" }
const _hoisted_13 = { class: "location-block-icon" }
const _hoisted_14 = { class: "location-block-title" }
const _hoisted_15 = {
  key: 0,
  class: "location-block-date location-block-date-aside"
}
const _hoisted_16 = {
  key: 0,
  class: "price-block"
}
const _hoisted_17 = { class: "price-block-amount ml-auto" }
const _hoisted_18 = {
  key: 3,
  class: "fw-ic gap-2"
}
const _hoisted_19 = { class: "sideplan-list-title" }
const _hoisted_20 = { class: "location-block" }
const _hoisted_21 = { class: "location-block-icon" }
const _hoisted_22 = { class: "location-block-title" }
const _hoisted_23 = { class: "sideplan-list-img" }

import { toRefs, watch, computed, ref, inject } from 'vue';
import { addImageScaler, compareSortingValue } from '@/core';
import {
  HomePlanImage,
  LotCountNeighborhood,
  PlanNeighborhoodList,
} from './../types';
import Modal from './modal/ImageModal.vue';
import ImageLightbox from './carousel/ImageLightbox.vue';
import LazyImage from './LazyImage.vue';
import LocationIcon from '@/assets/icons/Location.vue';

const BYNDER_CONTENT_TYPE = 'bynder';


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBarPlanListItem',
  props: {
    homePlan: {},
    qmiAndHomeplans: {},
    selectedLotId: {},
    neighborhoodId: {},
    isKioskMode: { type: Boolean },
    selectedNeighborhoodIds: {},
    lotsCount: {}
  },
  emits: ['voidHomePlanId'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const {
  homePlan,
  qmiAndHomeplans,
  selectedLotId,
  selectedNeighborhoodIds,
  lotsCount,
} = toRefs(props);

let planClicks = {};
const emit = __emit;

// injector
const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const availableLotsPresent = computed(() => {
  if (selectedNeighborhoodIds.value.length) {
    const count = lotsCount.value.find(
      (neighborhoodLot) =>
        neighborhoodLot.neighborhoodId === selectedNeighborhoodIds.value[0]
    )?.available;
    return !!count && count > 0;
  } else {
    let count = 0;
    for (const neighborhoodLot of lotsCount.value) {
      if (neighborhoodLot?.available) {
        count += neighborhoodLot.available;
      }
    }
    return !!count && count > 0;
  }
});
const changePlanClicks = () => {
  console.log('changePlanClicks');
  let isPlanClicked = false;
  Object.keys(planClicks).forEach((planId) => {
    qmiAndHomeplans.value.forEach((plan) => {
      let data = !plan.job_number ? plan.plan_id : plan.job_number;
      if (data === planId) {
        isPlanClicked = true;
      }
    });
  });
  if (!isPlanClicked) {
    for (const key in planClicks) delete planClicks[key];
  }
};

const firstBynderAssetUrl = (images: HomePlanImage[] | undefined) =>
  images?.find((image) => image.content_type_name === BYNDER_CONTENT_TYPE)
    ?.asset_value;

// `thumbnail_img` is present on plans and absent on QMIs, but the API also sends
// it as an empty string for plans that have no neighborhood assets — so fall
// back to the plan's first Bynder photo, then to the QMI `image` array.
const getPlanImageUrl = (homePlan: any) =>
  homePlan.thumbnail_img ||
  firstBynderAssetUrl(homePlan.images) ||
  homePlan.image?.[0] ||
  '';

const formatDate = (moveInDate: string) => {
  let date = new Date(moveInDate);
  let formattedDate = date.toDateString().split(' ');
  return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
};

const formatPrice = (value: number) => {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
};

const addScaler = (url: string) => addImageScaler(url);

const sortNeighborhoods = (neighborhoods: PlanNeighborhoodList[]) => {
  const list = [] as PlanNeighborhoodList[];
  Object.assign(list, neighborhoods);
  return list.sort((first, second) =>
    compareSortingValue(first.neighborhood_name, second.neighborhood_name)
  );
};
const lightboxIdx = ref(-1);
const activeImages = ref([] as any[]);
const openLightbox = (
  event,
  images,
  qmiImages,
  thumbnailImage: string,
  index
) => {
  if (isSalesOrLandView.value && (images?.length > 0 || thumbnailImage)) {
    emit('voidHomePlanId');
    event?.stopPropagation?.();
    activeImages.value = [];
    if (images?.length) {
      activeImages.value = images
        .filter((img) => img.content_type_name === 'bynder')
        .map((img) => ({
          asset_value: img.asset_value,
          alt_tag: img.alt_tag ?? '',
          caption: img.caption ?? '',
        }));
    } else if (qmiImages?.length) {
      activeImages.value = qmiImages.map((img) => ({
        asset_value: img,
        alt_tag: '',
        caption: '',
      }));
    } else if (thumbnailImage) {
      activeImages.value = [
        {
          asset_value: thumbnailImage,
          alt_tag: '',
          caption: '',
        },
      ];
    }
    lightboxIdx.value = index;
  }
};

const closeLightbox = () => {
  lightboxIdx.value = -1;
  activeImages.value = [];
};
watch(selectedLotId, (newVal) => {
  if (newVal) {
    planClicks = {};
  }
});

watch(qmiAndHomeplans, () => {
  changePlanClicks();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(homePlan).price_low_with_premium >= 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(homePlan).plan_name), 1),
          (_unref(homePlan).price_low_with_premium && availableLotsPresent.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "price-block-text" }, "Starts at", -1)),
                _createElementVNode("span", _hoisted_5, _toDisplayString(formatPrice(_unref(homePlan).price_low_with_premium)), 1)
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "price-block-text" }, "Price not available at this time", -1)
              ]))]))
        ]))
      : _createCommentVNode("", true),
    (_unref(homePlan).price_low_with_premium >= 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortNeighborhoods(_unref(homePlan).neighborhoods), (neighborhood) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "location-block",
              key: neighborhood.neighborhood_code
            }, [
              _createElementVNode("i", _hoisted_8, [
                _createVNode(LocationIcon)
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(neighborhood.neighborhood_name), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(homePlan).price >= 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
          _createElementVNode("li", {
            class: _normalizeClass([
          !_unref(homePlan).isFuturePlan &&
          _unref(homePlan).status?.toLowerCase() !== 'future home'
            ? 'qmi-card-detail'
            : 'flexDiv gap-1',
        ])
          }, [
            _createElementVNode("span", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _createElementVNode("i", _hoisted_13, [
                  _createVNode(LocationIcon)
                ]),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(homePlan).address), 1)
              ]),
              (_unref(homePlan).move_in_date)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, " Move-in date: " + _toDisplayString(new Date() >= new Date((_unref(homePlan)).move_in_date)
                ? 'Immediate'
                : formatDate(_unref(homePlan).move_in_date)), 1))
                : _createCommentVNode("", true)
            ]),
            (
            _unref(homePlan).price > 0 &&
            !(
              _unref(homePlan).isFuturePlan ||
              _unref(homePlan).status?.toLowerCase() === 'future home'
            )
          )
              ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(formatPrice(_unref(homePlan).price)), 1)
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_unref(homePlan).price >= 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
          _createElementVNode("li", _hoisted_19, _toDisplayString(`${_unref(homePlan).plan_market_name} ${_unref(homePlan).elevation}`), 1),
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("i", _hoisted_21, [
              _createVNode(LocationIcon)
            ]),
            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(homePlan).neighborhood_name), 1)
          ]),
          (_unref(homePlan).isFuturePlan ||
              _unref(homePlan).status?.toLowerCase() === 'future home')
            ? (_openBlock(), _createElementBlock("li", {
                key: 0,
                class: "btn qmi",
                style: _normalizeStyle({ 'background-color': _unref(homePlan).color })
              }, " Future Home ", 4))
            : (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: "btn qmi",
                style: _normalizeStyle({ 'background-color': _unref(homePlan).color })
              }, " Quick Move-in ", 4))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createVNode(LazyImage, {
        src: addScaler(getPlanImageUrl(_unref(homePlan))),
        alt: _unref(homePlan).plan_name,
        isNeighborhoodImage: false,
        onClick: _cache[0] || (_cache[0] = 
          (e) =>
            openLightbox(
              e,
              _unref(homePlan).images,
              _unref(homePlan).image,
              getPlanImageUrl(_unref(homePlan)),
              0
            )
        )
      }, null, 8, ["src", "alt"]),
      (lightboxIdx.value > -1)
        ? (_openBlock(), _createBlock(Modal, {
            key: 0,
            "default-state-of-modal": true,
            "dialog-pannel-classes": 'asset-lightbox-modal',
            "modal-outer-container-classes": 'xxxxl:max-w-[1248px] mx-auto',
            onModalClosed: closeLightbox
          }, {
            modalContent: _withCtx(() => [
              _createVNode(ImageLightbox, {
                "slider-data": activeImages.value,
                "current-slide": lightboxIdx.value
              }, null, 8, ["slider-data", "current-slide"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})